// Merge Home FAQ and new FAQ items, deduplicate by question
export const mergedFaqs: FaqItem[] = [
  {
    id: 1,
    question: 'Apa sih manfaat utama SMARTSECURE buat aku?',
    answer: (
      <div>
        <p className="mb-2 font-semibold">
          Intinya: Kamu bakal langsung dapat notifikasi kalau data kamu bocor!
        </p>
        <p className="mb-2">
          Kami akan kasih tahu kamu setiap kali data pribadi digitalmu muncul di
          kebocoran data terbaru. Jadi, kamu bisa selalu selangkah lebih aman
          dari ancaman siber. Tenang aja, kami juga kasih tips langkah-langkah
          yang harus kamu lakukan kalau itu terjadi.
        </p>
        <p className="mb-2">
          Data yang kami pantau lewat email atau nomor HP kamu, dibagi jadi tiga
          kategori:
        </p>
        <ul className="list-disc pl-5 mb-2">
          <li>
            <b>Data akses:</b> alamat email, password, username, dan IP address
          </li>
          <li>
            <b>Data pribadi:</b> nomor KTP, paspor, SIM, nama lengkap, alamat,
            negara, gender, umur, kota, provinsi, dan tanggal lahir
          </li>
          <li>
            <b>Data pembayaran:</b> nomor kartu kredit/debit dan alamat
            penagihan
          </li>
        </ul>
      </div>
    ),
  },
  {
    id: 2,
    question: 'Gimana sih cara kerja Perlindungan Identitas SMARTSECURE?',
    answer: (
      <div>
        <ol className="list-decimal pl-5 space-y-2">
          <li>
            <b>Daftar & Tambahkan Data:</b> Cukup langganan SMARTSECURE dan
            masukin email atau Gmail yang mau kamu pantau langsung di aplikasi
            MySF. <b>Gak perlu install aplikasi tambahan!</b>
          </li>
          <li>
            <b>Pemantauan Otomatis:</b> Sistem kami bakal mantau internet
            (termasuk dark web!) 24/7 buat cek kalau-kalau data kamu bocor.
          </li>
          <li>
            <b>Notifikasi Kilat:</b> Kalau ada kebocoran, kamu langsung dapat
            notifikasi di aplikasi plus saran langkah yang bisa kamu ambil.
          </li>
        </ol>
      </div>
    ),
  },
  {
    id: 3,
    question: 'Gimana cara nambahin email biar dipantau SMARTSECURE?',
    answer: (
      <div>
        <p className="mb-2">
          Kamu bisa pantau sampai <b>10 akun</b> (email & nomor HP) sekaligus.
          Untuk email, caranya gampang:
        </p>
        <ol className="list-decimal pl-5 space-y-2">
          <li>
            <b>Masukkan alamat email</b> — Ketik email yang mau kamu amankan di
            aplikasi MySF.
          </li>
          <li>
            <b>Verifikasi email</b> — Klik link verifikasi yang dikirim ke inbox
            email kamu.
          </li>
          <li>
            <b>Tetap aman</b> — Dapatkan notifikasi instan di MySF setiap kali
            data kamu terdeteksi bocor.
          </li>
        </ol>
      </div>
    ),
  },
  {
    id: 4,
    question: 'Di mana aku bisa lihat dashboard SMARTSECURE-ku?',
    answer: (
      <div>
        <p>
          Login ke aplikasi MySF pakai akun kamu. Klik menu <b>"SMARTSECURE"</b>{' '}
          dan kamu bakal nemuin link ke dashboard setelah berlangganan layanan
          ini.
        </p>
      </div>
    ),
  },
  {
    id: 5,
    question: 'Kenapa sih data pribadi harus dijaga banget?',
    answer: (
      <div>
        <p className="mb-2">
          Kalau data pribadi bocor, efeknya bisa ke mana-mana, lho:
        </p>
        <ul className="list-disc pl-5 mb-2">
          <li>
            <b>Finansial –</b> Data kamu bisa dipakai buat belanja atau
            transaksi tanpa sepengetahuanmu.
          </li>
          <li>
            <b>Reputasi –</b> Orang lain bisa pura-pura jadi kamu di medsos,
            bisa bikin citra kamu jelek.
          </li>
          <li>
            <b>Privasi –</b> Akses ke file, foto, atau email pribadi tanpa izin
            itu nggak enak banget dan bisa bikin gak nyaman.
          </li>
          <li>
            <b>Waktu –</b> Urus masalah data bocor itu makan waktu dan energi,
            memulai dari kontak CS, update data, sampai balikin akun.
          </li>
        </ul>
      </div>
    ),
  },
  {
    id: 6,
    question: 'Apa yang terjadi sama data yang aku masukin?',
    answer: (
      <div>
        <p>
          Semua data yang kamu masukin langsung dienkripsi (diamankan). Kami
          juga langsung cek apakah data kamu pernah bocor sebelumnya. Setelah
          itu, data kamu bakal terus dipantau supaya kalau ada kebocoran baru,
          kamu langsung tahu.
        </p>
      </div>
    ),
  },
  {
    id: 7,
    question: 'Kalau data aku udah pernah bocor, masih bisa diselamatin nggak?',
    answer: (
      <div>
        <p>
          Masih banget!
          <br />
          Biasanya ada jeda waktu antara data dicuri sama data itu dipakai buat
          hal negatif. Nah, di waktu inilah kamu bisa bertindak cepat, dan di
          sinilah peran SMARTSECURE. Makanya, produk ini dijuluki{' '}
          <b>"alarm kebakaran digital"</b> — biar kamu bisa selamatin data
          sebelum terlambat!
        </p>
      </div>
    ),
  },
];

import { useState } from 'react';
import { FaChevronDown, FaChevronUp, FaQuestionCircle } from 'react-icons/fa';

export interface FaqItem {
  id: number;
  question: string;
  answer: string | React.ReactNode;
}

interface FaqProps {
  items?: FaqItem[];
  className?: string;
}

export default function Faq({ items, className = '' }: FaqProps) {
  const [openItem, setOpenItem] = useState<number | null>(null);
  const faqList = items && items.length > 0 ? items : mergedFaqs;
  const toggleItem = (id: number) => {
    setOpenItem(openItem === id ? null : id);
  };
  return (
    <div className={`bg-white rounded-2xl p-6 shadow-sm mb-6 ${className}`}>
      <h3 className="text-xl font-bold mb-4 flex items-center">
        <FaQuestionCircle className="mr-2 text-[#3723B5]" />
        Pertanyaan yang Sering Ditanyain
      </h3>
      <div className="space-y-3">
        {faqList.map((item) => (
          <div
            key={item.id}
            className="border-2 border-[#3723B5] rounded-xl overflow-hidden"
          >
            <button
              className="w-full px-4 py-3 flex justify-between items-center text-left hover:bg-gray-50 transition-colors"
              onClick={() => toggleItem(item.id)}
            >
              <span className="font-bold pr-4">{item.question}</span>
              {openItem === item.id ? (
                <FaChevronUp className="text-[#3723B5] ml-2 transition-transform rotate-180" />
              ) : (
                <FaChevronDown className="text-[#3723B5] ml-2 transition-transform" />
              )}
            </button>
            {openItem === item.id && (
              <div className="px-4 py-3 border-t border-[#3723B5] bg-white">
                <div className="text-sm text-gray-600">{item.answer}</div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
